var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconX = function SvgIconX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.244 13.25h2.308l-5.04 5.76 5.93 7.84h-4.657l-3.637-4.756-4.162 4.756H11.68l5.39-6.163L11.254 13.25h4.777l3.288 4.347zm-.81 12.213h1.279l-8.253-10.895H13.28z",
    fill: "#2F2F4B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 18,
    stroke: "#2F2F4B",
    strokeWidth: 1.5
  })));
};
export default SvgIconX;